import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { createNamespace, value2DomUnit } from '../../utils';
import { inherit } from '../../utils/functional';

var _createNamespace = createNamespace('icon'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

function Icon( // @ts-ignore
h, props, slots, ctx) {
  var defaultSlots = slots.default && slots.default();

  if (defaultSlots) {
    return h("i", _mergeJSXProps([{
      "class": bem(),
      "style": {
        fill: props.fill,
        width: value2DomUnit(props.size),
        height: value2DomUnit(props.size)
      }
    }, inherit(ctx, true)]), [defaultSlots]);
  }

  if (props.name === 'square-uncheck' || props.name === 'radio-uncheck') {
    return h("i", _mergeJSXProps2([{
      "class": bem([props.name]),
      "style": {
        fill: props.fill,
        width: value2DomUnit(props.size),
        height: value2DomUnit(props.size)
      }
    }, inherit(ctx, true)]));
  }

  return h("i", _mergeJSXProps3([{
    "class": bem([props.name]),
    "style": {
      fill: props.fill,
      width: value2DomUnit(props.size),
      height: value2DomUnit(props.size)
    },
    "domProps": {
      "innerHTML": require("!html-loader!./icon/" + props.name + ".svg")
    }
  }, inherit(ctx, true)]));
}

Icon.props = {
  name: String,
  size: [Number, String],
  fill: String
};
export default createComponent(Icon);